import { useTranslation } from 'react-i18next';

type ReferralLevel = {
  id: string;
  label: string;
};

function ReferralLevelsComponent(): ReferralLevel[] {
  const { t } = useTranslation();
  const referralLevels = [
    {
      id: '1',
      label: `${t('Level')} 1`,
    },
    {
      id: '2',
      label: `${t('Level')} 2`,
    },
    {
      id: '3',
      label: `${t('Level')} 3`,
    },
  ];

  return referralLevels;
}

export { ReferralLevelsComponent };
